//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.1.0 (NJsonSchema v11.5.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import {
    ApiActivity,
    IApiActivity,
    ApiNamedListItem,
    ApiIdNameItem,
    IApiIdNameItem,
    ApiMemberInfo,
    ApiNote,
    IApiNote,
    ApiFileInfo,
    IApiFileInfo,
    ApiListItemPosition,
    columnMap,
    keyMap,
    ApiRange,
    ApiText,
    IApiMemberInfo,
    ApiCreateMemberRequest,
    ApiDateRange,
    ApiNoteListItem,
    BackgroundProcessEnum,
    BackgroundProcessStatusEnum,
    BackgroundProcessStepStatus,
    NoteTypeEnum,
    SocialNetworkEnum,
    FileUploadErrorEnum,
    ApiExternalAccountInfo,
    Module,
    Permission,
    ServicesEnum,
    ApiCreatorInfo,
    FileResponse,
    FileParameter,
    FileValidationModel,
    TimerTaskType,
    Gender
} from 'sc-common';
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class ChaptersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getAll(projectId: number): Observable<ApiChapterItem[]> {
        let url_ = this.baseUrl + "/api/content-manager/projects/{projectId}/chapters";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiChapterItem[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiChapterItem[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ApiChapterItem[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiChapterItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    create(projectId: number, model: ApiChapter): Observable<void> {
        let url_ = this.baseUrl + "/api/content-manager/projects/{projectId}/chapters";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getList(projectId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiChapterListItem> {
        let url_ = this.baseUrl + "/api/content-manager/projects/{projectId}/chapters/list?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiChapterListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiChapterListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiChapterListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiChapterListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateOrder(projectId: number, positionData: ApiListItemPosition[]): Observable<void> {
        let url_ = this.baseUrl + "/api/content-manager/projects/{projectId}/chapters/update-pos";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(positionData);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdateOrder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    update(projectId: number, chapterId: number, updatedChapter: ApiChapter): Observable<void> {
        let url_ = this.baseUrl + "/api/content-manager/projects/{projectId}/chapters/{chapterId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (chapterId === undefined || chapterId === null)
            throw new Error("The parameter 'chapterId' must be defined.");
        url_ = url_.replace("{chapterId}", encodeURIComponent("" + chapterId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updatedChapter);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    delete(projectId: number, chapterId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/content-manager/projects/{projectId}/chapters/{chapterId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (chapterId === undefined || chapterId === null)
            throw new Error("The parameter 'chapterId' must be defined.");
        url_ = url_.replace("{chapterId}", encodeURIComponent("" + chapterId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    hasChapters(projectId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/content-manager/projects/{projectId}/chapters/has-chapters";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHasChapters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHasChapters(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<boolean>;
        }));
    }

    protected processHasChapters(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getSubjectCategoryList(projectId: number, subjectCategoryType: SubjectCategoryType, odataQuery: string | undefined): Observable<ApiPageResultOfApiChapterSubjectCategoryListItem> {
        let url_ = this.baseUrl + "/api/content-manager/projects/{projectId}/chapters/subject-categories/{subjectCategoryType}?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (subjectCategoryType === undefined || subjectCategoryType === null)
            throw new Error("The parameter 'subjectCategoryType' must be defined.");
        url_ = url_.replace("{subjectCategoryType}", encodeURIComponent("" + subjectCategoryType));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubjectCategoryList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubjectCategoryList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiChapterSubjectCategoryListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiChapterSubjectCategoryListItem>;
        }));
    }

    protected processGetSubjectCategoryList(response: HttpResponseBase): Observable<ApiPageResultOfApiChapterSubjectCategoryListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiChapterSubjectCategoryListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    replaceSubjectCategories(projectId: number, chapterId: number, request: ApiReplaceSubjectCategoryRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/content-manager/projects/{projectId}/chapters/{chapterId}/subject-categories";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (chapterId === undefined || chapterId === null)
            throw new Error("The parameter 'chapterId' must be defined.");
        url_ = url_.replace("{chapterId}", encodeURIComponent("" + chapterId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReplaceSubjectCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReplaceSubjectCategories(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processReplaceSubjectCategories(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ColorsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    list(): Observable<ApiColor[]> {
        let url_ = this.baseUrl + "/api/content-manager/colors";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiColor[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiColor[]>;
        }));
    }

    protected processList(response: HttpResponseBase): Observable<ApiColor[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiColor.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ContentEditorsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(projectId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiContentEditorListItem> {
        let url_ = this.baseUrl + "/api/content-manager/projects/{projectId}/content-editors/list?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiContentEditorListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiContentEditorListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiContentEditorListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiContentEditorListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    add(projectId: number, model: ApiContentEditor): Observable<void> {
        let url_ = this.baseUrl + "/api/content-manager/projects/{projectId}/content-editors";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    delete(projectId: number, memberId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/content-manager/projects/{projectId}/content-editors/{memberId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EditorChaptersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getAll(projectId: number): Observable<ApiChapterItem[]> {
        let url_ = this.baseUrl + "/api/content-manager/projects/{projectId}/editor-chapters";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiChapterItem[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiChapterItem[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ApiChapterItem[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiChapterItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FilesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getEditorDocuments(projectId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiProjectDocument> {
        let url_ = this.baseUrl + "/api/content-manager/projects/{projectId}/files/editor-documents?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditorDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditorDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiProjectDocument>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiProjectDocument>;
        }));
    }

    protected processGetEditorDocuments(response: HttpResponseBase): Observable<ApiPageResultOfApiProjectDocument> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiProjectDocument.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getAttachmentDocuments(projectId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiProjectDocument> {
        let url_ = this.baseUrl + "/api/content-manager/projects/{projectId}/files/attachments?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttachmentDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttachmentDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiProjectDocument>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiProjectDocument>;
        }));
    }

    protected processGetAttachmentDocuments(response: HttpResponseBase): Observable<ApiPageResultOfApiProjectDocument> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiProjectDocument.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getEditorDocumentFile(projectId: number, documentId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/content-manager/projects/{projectId}/files/{documentId}/editor";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditorDocumentFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditorDocumentFile(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetEditorDocumentFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getAttachmentDocumentFile(projectId: number, documentId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/content-manager/projects/{projectId}/files/{documentId}/attachment";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttachmentDocumentFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttachmentDocumentFile(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetAttachmentDocumentFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    deleteDocument(projectId: number, documentId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/content-manager/projects/{projectId}/files/{documentId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processDeleteDocument(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getValidationRules(projectId: number): Observable<FileValidationModel> {
        let url_ = this.baseUrl + "/api/content-manager/projects/{projectId}/files/validation-rules";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetValidationRules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetValidationRules(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileValidationModel>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileValidationModel>;
        }));
    }

    protected processGetValidationRules(response: HttpResponseBase): Observable<FileValidationModel> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileValidationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

            addDocumentUrl(projectId: number, name: string | null | undefined, document: FileParameter | null | undefined): string {
            
            let url_ = this.baseUrl + "/api/content-manager/projects/{projectId}/files?";
                        if (projectId === undefined || projectId === null)
                            throw new Error("The parameter 'projectId' must be defined.");
                        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
                        if (name !== undefined && name !== null)
                            url_ += "name=" + encodeURIComponent("" + name) + "&";
                        url_ = url_.replace(/[?&]$/, "");

            return url_;
        }

    

    addDocument(projectId: number, name: string | null | undefined, document: FileParameter | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/content-manager/projects/{projectId}/files?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (document !== null && document !== undefined)
            content_.append("document", document.data, document.fileName ? document.fileName : "document");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processAddDocument(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MembersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    findMembers(query: string | null | undefined): Observable<ApiMember[]> {
        let url_ = this.baseUrl + "/api/content-manager/members/find?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindMembers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindMembers(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiMember[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiMember[]>;
        }));
    }

    protected processFindMembers(response: HttpResponseBase): Observable<ApiMember[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiMember.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MemberSettingsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    hideWelcomeBlock(): Observable<void> {
        let url_ = this.baseUrl + "/api/content-manager/member-settings/hide-welcome-block";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHideWelcomeBlock(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHideWelcomeBlock(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processHideWelcomeBlock(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    haveLogged(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/content-manager/member-settings/have-logged";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHaveLogged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHaveLogged(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<boolean>;
        }));
    }

    protected processHaveLogged(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class NotesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    list(projectId: number): Observable<ApiNoteListItem[]> {
        let url_ = this.baseUrl + "/api/content-manager/projects/{projectId}/notes/list";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiNoteListItem[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiNoteListItem[]>;
        }));
    }

    protected processList(response: HttpResponseBase): Observable<ApiNoteListItem[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiNoteListItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    create(projectId: number, model: ApiNote): Observable<void> {
        let url_ = this.baseUrl + "/api/content-manager/projects/{projectId}/notes";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    update(projectId: number, noteId: number, model: ApiNote): Observable<void> {
        let url_ = this.baseUrl + "/api/content-manager/projects/{projectId}/notes/{noteId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (noteId === undefined || noteId === null)
            throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    delete(projectId: number, noteId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/content-manager/projects/{projectId}/notes/{noteId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (noteId === undefined || noteId === null)
            throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PaperNotesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    list(projectId: number, paperId: number): Observable<ApiNoteListItem[]> {
        let url_ = this.baseUrl + "/api/content-manager/projects/{projectId}/papers/{paperId}/notes/list";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiNoteListItem[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiNoteListItem[]>;
        }));
    }

    protected processList(response: HttpResponseBase): Observable<ApiNoteListItem[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiNoteListItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    create(projectId: number, paperId: number, model: ApiNote): Observable<void> {
        let url_ = this.baseUrl + "/api/content-manager/projects/{projectId}/papers/{paperId}/notes";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    update(projectId: number, paperId: number, noteId: number, model: ApiNote): Observable<void> {
        let url_ = this.baseUrl + "/api/content-manager/projects/{projectId}/papers/{paperId}/notes/{noteId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (noteId === undefined || noteId === null)
            throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    delete(projectId: number, paperId: number, noteId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/content-manager/projects/{projectId}/papers/{paperId}/notes/{noteId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (noteId === undefined || noteId === null)
            throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PapersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(projectId: number, memberId: number | null | undefined, odataQuery: string | undefined): Observable<ApiPageResultOfApiPaperListItem> {
        let url_ = this.baseUrl + "/api/content-manager/projects/{projectId}/papers/list?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (memberId !== undefined && memberId !== null)
            url_ += "memberId=" + encodeURIComponent("" + memberId) + "&";
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiPaperListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiPaperListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiPaperListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiPaperListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getPdf(projectId: number, paperId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/content-manager/projects/{projectId}/papers/{paperId}/pdf";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetPdf(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    assignChapter(projectId: number, paperId: number, chapterId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/content-manager/projects/{projectId}/papers/{paperId}/assign-chapter/{chapterId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (chapterId === undefined || chapterId === null)
            throw new Error("The parameter 'chapterId' must be defined.");
        url_ = url_.replace("{chapterId}", encodeURIComponent("" + chapterId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignChapter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignChapter(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processAssignChapter(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    unassignChapter(projectId: number, paperId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/content-manager/projects/{projectId}/papers/{paperId}/unassign-chapter";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnassignChapter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnassignChapter(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUnassignChapter(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getAuthor(projectId: number, memberId: number): Observable<ApiAuthor> {
        let url_ = this.baseUrl + "/api/content-manager/projects/{projectId}/papers/authors/{memberId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuthor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuthor(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiAuthor>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiAuthor>;
        }));
    }

    protected processGetAuthor(response: HttpResponseBase): Observable<ApiAuthor> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiAuthor.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    assignColor(projectId: number, paperId: number, colorName: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/content-manager/projects/{projectId}/papers/{paperId}/assign-color?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (colorName !== undefined && colorName !== null)
            url_ += "colorName=" + encodeURIComponent("" + colorName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignColor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignColor(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processAssignColor(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    unassignColor(projectId: number, paperId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/content-manager/projects/{projectId}/papers/{paperId}/unassign-color";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnassignColor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnassignColor(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUnassignColor(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    reject(projectId: number, paperId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/content-manager/projects/{projectId}/papers/{paperId}/reject";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReject(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processReject(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    accept(projectId: number, paperId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/content-manager/projects/{projectId}/papers/{paperId}/accept";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccept(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccept(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processAccept(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PlagiarismReportsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    checkForPlagiarism(projectId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/content-manager/projects/{projectId}/plagiarism-reports/check-for-plagiarism";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckForPlagiarism(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckForPlagiarism(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processCheckForPlagiarism(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getList(projectId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiPaperPlagiarismReportListItem> {
        let url_ = this.baseUrl + "/api/content-manager/projects/{projectId}/plagiarism-reports/list?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiPaperPlagiarismReportListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiPaperPlagiarismReportListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiPaperPlagiarismReportListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiPaperPlagiarismReportListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getStatus(projectId: number): Observable<ApiProjectPlagiarismCheckStatus> {
        let url_ = this.baseUrl + "/api/content-manager/projects/{projectId}/plagiarism-reports/status";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiProjectPlagiarismCheckStatus>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiProjectPlagiarismCheckStatus>;
        }));
    }

    protected processGetStatus(response: HttpResponseBase): Observable<ApiProjectPlagiarismCheckStatus> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiProjectPlagiarismCheckStatus.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getReportSettings(): Observable<ApiTcaReportSettings> {
        let url_ = this.baseUrl + "/api/content-manager/plagiarism-reports/settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiTcaReportSettings>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiTcaReportSettings>;
        }));
    }

    protected processGetReportSettings(response: HttpResponseBase): Observable<ApiTcaReportSettings> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiTcaReportSettings.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getViewerUrl(projectId: number, paperId: number): Observable<string> {
        let url_ = this.baseUrl + "/api/content-manager/projects/{projectId}/plagiarism-reports/papers/{paperId}/viewer-url";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetViewerUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetViewerUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<string>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<string>;
        }));
    }

    protected processGetViewerUrl(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ProjectDetailsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getInfo(projectId: number): Observable<ApiProjectInfo> {
        let url_ = this.baseUrl + "/api/content-manager/projects/{projectId}/info";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiProjectInfo>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiProjectInfo>;
        }));
    }

    protected processGetInfo(response: HttpResponseBase): Observable<ApiProjectInfo> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiProjectInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    delete(projectId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/content-manager/projects/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    update(projectId: number, updateProject: ApiProject): Observable<void> {
        let url_ = this.baseUrl + "/api/content-manager/projects/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateProject);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getThemaList(projectId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiProjectThemaListItem> {
        let url_ = this.baseUrl + "/api/content-manager/projects/{projectId}/themas?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetThemaList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetThemaList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiProjectThemaListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiProjectThemaListItem>;
        }));
    }

    protected processGetThemaList(response: HttpResponseBase): Observable<ApiPageResultOfApiProjectThemaListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiProjectThemaListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateThemas(projectId: number, themaIds: number[]): Observable<void> {
        let url_ = this.baseUrl + "/api/content-manager/projects/{projectId}/themas";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(themaIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateThemas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateThemas(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdateThemas(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getThemaIdList(projectId: number): Observable<number[]> {
        let url_ = this.baseUrl + "/api/content-manager/projects/{projectId}/themas/all-ids";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetThemaIdList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetThemaIdList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<number[]>;
        }));
    }

    protected processGetThemaIdList(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getDetails(projectId: number): Observable<ApiProjectDetails> {
        let url_ = this.baseUrl + "/api/content-manager/projects/{projectId}/details";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiProjectDetails>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiProjectDetails>;
        }));
    }

    protected processGetDetails(response: HttpResponseBase): Observable<ApiProjectDetails> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiProjectDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    complete(projectId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/content-manager/projects/{projectId}/complete";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processComplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processComplete(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processComplete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    cancel(projectId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/content-manager/projects/{projectId}/cancel";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancel(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processCancel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    return(projectId: number, applyChanges: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/content-manager/projects/{projectId}/return?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (applyChanges === null)
            throw new Error("The parameter 'applyChanges' cannot be null.");
        else if (applyChanges !== undefined)
            url_ += "applyChanges=" + encodeURIComponent("" + applyChanges) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReturn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReturn(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processReturn(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    generateReport(projectId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/content-manager/projects/{projectId}/report";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateReport(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processGenerateReport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    downloadReport(projectId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/content-manager/projects/{projectId}/report";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadReport(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ProjectImportPapersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    importPapers(projectId: number): Observable<ApiImportPapersResult> {
        let url_ = this.baseUrl + "/api/content-manager/projects/{projectId}/import-papers";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportPapers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportPapers(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiImportPapersResult>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiImportPapersResult>;
        }));
    }

    protected processImportPapers(response: HttpResponseBase): Observable<ApiImportPapersResult> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiImportPapersResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ProjectsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(odataQuery: string | undefined): Observable<ApiPageResultOfApiProjectListItem> {
        let url_ = this.baseUrl + "/api/content-manager/projects?";
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiProjectListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiProjectListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiProjectListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiProjectListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    create(createRequest: ApiProjectCreateRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/content-manager/projects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getIdList(): Observable<number[]> {
        let url_ = this.baseUrl + "/api/content-manager/projects/all-ids";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIdList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIdList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<number[]>;
        }));
    }

    protected processGetIdList(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class SubjectCategoriesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getThemas(): Observable<ApiThema[]> {
        let url_ = this.baseUrl + "/api/content-manager/subject-categories/themas";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetThemas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetThemas(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiThema[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiThema[]>;
        }));
    }

    protected processGetThemas(response: HttpResponseBase): Observable<ApiThema[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiThema.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getTopics(): Observable<ApiTopic[]> {
        let url_ = this.baseUrl + "/api/content-manager/subject-categories/topics";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTopics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTopics(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiTopic[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiTopic[]>;
        }));
    }

    protected processGetTopics(response: HttpResponseBase): Observable<ApiTopic[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiTopic.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TitlesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    findTitles(findRequest: ApiFindTitleRequest): Observable<ApiIdNameItem[]> {
        let url_ = this.baseUrl + "/api/content-manager/titles/find";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(findRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindTitles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindTitles(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiIdNameItem[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiIdNameItem[]>;
        }));
    }

    protected processFindTitles(response: HttpResponseBase): Observable<ApiIdNameItem[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiIdNameItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class ApiChapterItem implements IApiChapterItem {
    id?: number;
    name?: string | null;
    pos?: number;

    constructor(data?: IApiChapterItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.pos = _data["pos"] !== undefined ? _data["pos"] : null as any;
        }
    }

    static fromJS(data: any): ApiChapterItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiChapterItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["pos"] = this.pos !== undefined ? this.pos : null as any;
        return data;
    }
}

export interface IApiChapterItem {
    id?: number;
    name?: string | null;
    pos?: number;
}

export class ApiPageResultOfApiChapterListItem implements IApiPageResultOfApiChapterListItem {
    items?: ApiChapterListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiChapterListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiChapterListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiChapterListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiChapterListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiChapterListItem {
    items?: ApiChapterListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiChapterListItem implements IApiChapterListItem {
    @keyMap()
    id?: number;
    @columnMap(() => Number)
    pos?: number;
    @columnMap(() => String)
    name?: string | null;

    constructor(data?: IApiChapterListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.pos = _data["pos"] !== undefined ? _data["pos"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
        }
    }

    static fromJS(data: any): ApiChapterListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiChapterListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["pos"] = this.pos !== undefined ? this.pos : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        return data;
    }
}

export interface IApiChapterListItem {
    id?: number;
    pos?: number;
    name?: string | null;
}

export class ApiChapter implements IApiChapter {
    name: string;

    constructor(data?: IApiChapter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
        }
    }

    static fromJS(data: any): ApiChapter {
        data = typeof data === 'object' ? data : {};
        let result = new ApiChapter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        return data;
    }
}

export interface IApiChapter {
    name: string;
}

export class ApiPageResultOfApiChapterSubjectCategoryListItem implements IApiPageResultOfApiChapterSubjectCategoryListItem {
    items?: ApiChapterSubjectCategoryListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiChapterSubjectCategoryListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiChapterSubjectCategoryListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiChapterSubjectCategoryListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiChapterSubjectCategoryListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiChapterSubjectCategoryListItem {
    items?: ApiChapterSubjectCategoryListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiChapterSubjectCategoryListItem implements IApiChapterSubjectCategoryListItem {
    @keyMap()
    id?: number;
    @columnMap(() => Number)
    pos?: number;
    @columnMap(() => String)
    chapter?: string | null;
    @columnMap(() => ApiSubjectCategory, true)
    themas?: ApiSubjectCategory[] | null;

    constructor(data?: IApiChapterSubjectCategoryListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.pos = _data["pos"] !== undefined ? _data["pos"] : null as any;
            this.chapter = _data["chapter"] !== undefined ? _data["chapter"] : null as any;
            if (Array.isArray(_data["themas"])) {
                this.themas = [] as any;
                for (let item of _data["themas"])
                    this.themas!.push(ApiSubjectCategory.fromJS(item));
            }
            else {
                this.themas = null as any;
            }
        }
    }

    static fromJS(data: any): ApiChapterSubjectCategoryListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiChapterSubjectCategoryListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["pos"] = this.pos !== undefined ? this.pos : null as any;
        data["chapter"] = this.chapter !== undefined ? this.chapter : null as any;
        if (Array.isArray(this.themas)) {
            data["themas"] = [];
            for (let item of this.themas)
                data["themas"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IApiChapterSubjectCategoryListItem {
    id?: number;
    pos?: number;
    chapter?: string | null;
    themas?: ApiSubjectCategory[] | null;
}

export class ApiSubjectCategory implements IApiSubjectCategory {
    subjectCategoryType?: SubjectCategoryType;
    code?: string | null;
    headingText?: string | null;

    constructor(data?: IApiSubjectCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subjectCategoryType = _data["subjectCategoryType"] !== undefined ? _data["subjectCategoryType"] : null as any;
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.headingText = _data["headingText"] !== undefined ? _data["headingText"] : null as any;
        }
    }

    static fromJS(data: any): ApiSubjectCategory {
        data = typeof data === 'object' ? data : {};
        let result = new ApiSubjectCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subjectCategoryType"] = this.subjectCategoryType !== undefined ? this.subjectCategoryType : null as any;
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["headingText"] = this.headingText !== undefined ? this.headingText : null as any;
        return data;
    }
}

export interface IApiSubjectCategory {
    subjectCategoryType?: SubjectCategoryType;
    code?: string | null;
    headingText?: string | null;
}

export enum SubjectCategoryType {
    BISAC = 0,
    BIC = 1,
    Thema = 2,
    LCSH = 3,
    WGS = 4,
    Topic = 5,
}

export class ApiReplaceSubjectCategoryRequest implements IApiReplaceSubjectCategoryRequest {
    subjectCategoryType?: SubjectCategoryType;
    subjectCategories?: ApiSubjectCategory[] | null;

    constructor(data?: IApiReplaceSubjectCategoryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subjectCategoryType = _data["subjectCategoryType"] !== undefined ? _data["subjectCategoryType"] : null as any;
            if (Array.isArray(_data["subjectCategories"])) {
                this.subjectCategories = [] as any;
                for (let item of _data["subjectCategories"])
                    this.subjectCategories!.push(ApiSubjectCategory.fromJS(item));
            }
            else {
                this.subjectCategories = null as any;
            }
        }
    }

    static fromJS(data: any): ApiReplaceSubjectCategoryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ApiReplaceSubjectCategoryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subjectCategoryType"] = this.subjectCategoryType !== undefined ? this.subjectCategoryType : null as any;
        if (Array.isArray(this.subjectCategories)) {
            data["subjectCategories"] = [];
            for (let item of this.subjectCategories)
                data["subjectCategories"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IApiReplaceSubjectCategoryRequest {
    subjectCategoryType?: SubjectCategoryType;
    subjectCategories?: ApiSubjectCategory[] | null;
}

export class ApiColor implements IApiColor {
    name?: string | null;
    value?: string | null;

    constructor(data?: IApiColor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.value = _data["value"] !== undefined ? _data["value"] : null as any;
        }
    }

    static fromJS(data: any): ApiColor {
        data = typeof data === 'object' ? data : {};
        let result = new ApiColor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["value"] = this.value !== undefined ? this.value : null as any;
        return data;
    }
}

export interface IApiColor {
    name?: string | null;
    value?: string | null;
}

export class ApiPageResultOfApiContentEditorListItem implements IApiPageResultOfApiContentEditorListItem {
    items?: ApiContentEditorListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiContentEditorListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiContentEditorListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiContentEditorListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiContentEditorListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiContentEditorListItem {
    items?: ApiContentEditorListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiContentEditorListItem implements IApiContentEditorListItem {
    @keyMap()
    memberId?: number;
    @columnMap(() => String)
    firstName?: string | null;
    @columnMap(() => String)
    lastName?: string | null;
    @columnMap(() => String)
    email?: string | null;

    constructor(data?: IApiContentEditorListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberId = _data["memberId"] !== undefined ? _data["memberId"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
        }
    }

    static fromJS(data: any): ApiContentEditorListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiContentEditorListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberId"] = this.memberId !== undefined ? this.memberId : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        return data;
    }
}

export interface IApiContentEditorListItem {
    memberId?: number;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
}

export class ApiContentEditor implements IApiContentEditor {
    memberId?: number;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;

    constructor(data?: IApiContentEditor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberId = _data["memberId"] !== undefined ? _data["memberId"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
        }
    }

    static fromJS(data: any): ApiContentEditor {
        data = typeof data === 'object' ? data : {};
        let result = new ApiContentEditor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberId"] = this.memberId !== undefined ? this.memberId : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        return data;
    }
}

export interface IApiContentEditor {
    memberId?: number;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
}

export class ApiPageResultOfApiProjectDocument implements IApiPageResultOfApiProjectDocument {
    items?: ApiProjectDocument[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiProjectDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiProjectDocument.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiProjectDocument {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiProjectDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiProjectDocument {
    items?: ApiProjectDocument[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiProjectDocument implements IApiProjectDocument {
    @keyMap()
    id?: number;
    @columnMap(() => String)
    name?: string | null;
    @columnMap(() => ApiFileInfo)
    file?: ApiFileInfo | null;

    constructor(data?: IApiProjectDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.file = _data["file"] ? ApiFileInfo.fromJS(_data["file"]) : null as any;
        }
    }

    static fromJS(data: any): ApiProjectDocument {
        data = typeof data === 'object' ? data : {};
        let result = new ApiProjectDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["file"] = this.file ? this.file.toJSON() : null as any;
        return data;
    }
}

export interface IApiProjectDocument {
    id?: number;
    name?: string | null;
    file?: ApiFileInfo | null;
}

export class ApiMember implements IApiMember {
    id?: number;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;

    constructor(data?: IApiMember) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
        }
    }

    static fromJS(data: any): ApiMember {
        data = typeof data === 'object' ? data : {};
        let result = new ApiMember();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        return data;
    }
}

export interface IApiMember {
    id?: number;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
}

export class ApiPageResultOfApiPaperListItem implements IApiPageResultOfApiPaperListItem {
    items?: ApiPaperListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiPaperListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiPaperListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiPaperListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiPaperListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiPaperListItem {
    items?: ApiPaperListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiPaperListItem implements IApiPaperListItem {
    @keyMap()
    id?: number;
    @columnMap(() => Number)
    rowNumber?: number;
    @columnMap(() => String)
    name?: string | null;
    @columnMap(() => ApiFileInfo)
    pdf?: ApiFileInfo | null;
    @columnMap(() => ApiChapterItem)
    editorChapter?: ApiChapterItem | null;
    @columnMap(() => ApiChapterItem)
    chapter?: ApiChapterItem | null;
    @columnMap(() => Boolean)
    isRejected?: boolean;
    @columnMap(() => ApiAuthorCount, true)
    authorCounts?: ApiAuthorCount[] | null;
    @columnMap(() => ApiPaperNote, true)
    comments?: ApiPaperNote[] | null;
    @columnMap(() => ApiColor)
    color?: ApiColor | null;

    constructor(data?: IApiPaperListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.rowNumber = _data["rowNumber"] !== undefined ? _data["rowNumber"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.pdf = _data["pdf"] ? ApiFileInfo.fromJS(_data["pdf"]) : null as any;
            this.editorChapter = _data["editorChapter"] ? ApiChapterItem.fromJS(_data["editorChapter"]) : null as any;
            this.chapter = _data["chapter"] ? ApiChapterItem.fromJS(_data["chapter"]) : null as any;
            this.isRejected = _data["isRejected"] !== undefined ? _data["isRejected"] : null as any;
            if (Array.isArray(_data["authorCounts"])) {
                this.authorCounts = [] as any;
                for (let item of _data["authorCounts"])
                    this.authorCounts!.push(ApiAuthorCount.fromJS(item));
            }
            else {
                this.authorCounts = null as any;
            }
            if (Array.isArray(_data["comments"])) {
                this.comments = [] as any;
                for (let item of _data["comments"])
                    this.comments!.push(ApiPaperNote.fromJS(item));
            }
            else {
                this.comments = null as any;
            }
            this.color = _data["color"] ? ApiColor.fromJS(_data["color"]) : null as any;
        }
    }

    static fromJS(data: any): ApiPaperListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPaperListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["rowNumber"] = this.rowNumber !== undefined ? this.rowNumber : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["pdf"] = this.pdf ? this.pdf.toJSON() : null as any;
        data["editorChapter"] = this.editorChapter ? this.editorChapter.toJSON() : null as any;
        data["chapter"] = this.chapter ? this.chapter.toJSON() : null as any;
        data["isRejected"] = this.isRejected !== undefined ? this.isRejected : null as any;
        if (Array.isArray(this.authorCounts)) {
            data["authorCounts"] = [];
            for (let item of this.authorCounts)
                data["authorCounts"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.comments)) {
            data["comments"] = [];
            for (let item of this.comments)
                data["comments"].push(item ? item.toJSON() : null as any);
        }
        data["color"] = this.color ? this.color.toJSON() : null as any;
        return data;
    }
}

export interface IApiPaperListItem {
    id?: number;
    rowNumber?: number;
    name?: string | null;
    pdf?: ApiFileInfo | null;
    editorChapter?: ApiChapterItem | null;
    chapter?: ApiChapterItem | null;
    isRejected?: boolean;
    authorCounts?: ApiAuthorCount[] | null;
    comments?: ApiPaperNote[] | null;
    color?: ApiColor | null;
}

export class ApiAuthorCount implements IApiAuthorCount {
    memberId?: number;
    fullName?: string | null;
    count?: number;

    constructor(data?: IApiAuthorCount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberId = _data["memberId"] !== undefined ? _data["memberId"] : null as any;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : null as any;
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
        }
    }

    static fromJS(data: any): ApiAuthorCount {
        data = typeof data === 'object' ? data : {};
        let result = new ApiAuthorCount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberId"] = this.memberId !== undefined ? this.memberId : null as any;
        data["fullName"] = this.fullName !== undefined ? this.fullName : null as any;
        data["count"] = this.count !== undefined ? this.count : null as any;
        return data;
    }
}

export interface IApiAuthorCount {
    memberId?: number;
    fullName?: string | null;
    count?: number;
}

export class ApiPaperNote implements IApiPaperNote {
    date?: Date;
    commenter?: string | null;
    description?: string | null;

    constructor(data?: IApiPaperNote) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : null as any;
            this.commenter = _data["commenter"] !== undefined ? _data["commenter"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
        }
    }

    static fromJS(data: any): ApiPaperNote {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPaperNote();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : null as any;
        data["commenter"] = this.commenter !== undefined ? this.commenter : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        return data;
    }
}

export interface IApiPaperNote {
    date?: Date;
    commenter?: string | null;
    description?: string | null;
}

export class ApiAuthor implements IApiAuthor {
    memberId?: number;
    fullName?: string | null;

    constructor(data?: IApiAuthor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberId = _data["memberId"] !== undefined ? _data["memberId"] : null as any;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : null as any;
        }
    }

    static fromJS(data: any): ApiAuthor {
        data = typeof data === 'object' ? data : {};
        let result = new ApiAuthor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberId"] = this.memberId !== undefined ? this.memberId : null as any;
        data["fullName"] = this.fullName !== undefined ? this.fullName : null as any;
        return data;
    }
}

export interface IApiAuthor {
    memberId?: number;
    fullName?: string | null;
}

export class ApiPageResultOfApiPaperPlagiarismReportListItem implements IApiPageResultOfApiPaperPlagiarismReportListItem {
    items?: ApiPaperPlagiarismReportListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiPaperPlagiarismReportListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiPaperPlagiarismReportListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiPaperPlagiarismReportListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiPaperPlagiarismReportListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiPaperPlagiarismReportListItem {
    items?: ApiPaperPlagiarismReportListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiPaperPlagiarismReportListItem implements IApiPaperPlagiarismReportListItem {
    @keyMap()
    id?: number;
    @columnMap(() => String)
    paperName?: string | null;
    @columnMap(() => Number)
    checkResult?: number | null;
    @columnMap(() => Boolean)
    isRejected?: boolean;
    status?: PaperPlagiarismCheckStatus;

    constructor(data?: IApiPaperPlagiarismReportListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.paperName = _data["paperName"] !== undefined ? _data["paperName"] : null as any;
            this.checkResult = _data["checkResult"] !== undefined ? _data["checkResult"] : null as any;
            this.isRejected = _data["isRejected"] !== undefined ? _data["isRejected"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
        }
    }

    static fromJS(data: any): ApiPaperPlagiarismReportListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPaperPlagiarismReportListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["paperName"] = this.paperName !== undefined ? this.paperName : null as any;
        data["checkResult"] = this.checkResult !== undefined ? this.checkResult : null as any;
        data["isRejected"] = this.isRejected !== undefined ? this.isRejected : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        return data;
    }
}

export interface IApiPaperPlagiarismReportListItem {
    id?: number;
    paperName?: string | null;
    checkResult?: number | null;
    isRejected?: boolean;
    status?: PaperPlagiarismCheckStatus;
}

export enum PaperPlagiarismCheckStatus {
    Unchecked = 0,
    Checked = 1,
    Failed = 2,
}

export class ApiProjectPlagiarismCheckStatus implements IApiProjectPlagiarismCheckStatus {
    status?: ProjectPlagiarismCheckStatus;

    constructor(data?: IApiProjectPlagiarismCheckStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
        }
    }

    static fromJS(data: any): ApiProjectPlagiarismCheckStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ApiProjectPlagiarismCheckStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status !== undefined ? this.status : null as any;
        return data;
    }
}

export interface IApiProjectPlagiarismCheckStatus {
    status?: ProjectPlagiarismCheckStatus;
}

export enum ProjectPlagiarismCheckStatus {
    Unchecked = 0,
    CreatingSubmissions = 1,
    PollingSubmissions = 2,
    GeneratingReports = 3,
    PollingReports = 4,
    Checked = 5,
    Failed = 6,
    FinishedWithErrors = 7,
}

export class ApiTcaReportSettings implements IApiTcaReportSettings {
    excludeAbstract?: boolean;
    excludeSmallMatches?: boolean;
    excludeMethods?: boolean;
    excludeBibliography?: boolean;
    excludeQuotes?: boolean;
    excludeCitations?: boolean;

    constructor(data?: IApiTcaReportSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.excludeAbstract = _data["excludeAbstract"] !== undefined ? _data["excludeAbstract"] : null as any;
            this.excludeSmallMatches = _data["excludeSmallMatches"] !== undefined ? _data["excludeSmallMatches"] : null as any;
            this.excludeMethods = _data["excludeMethods"] !== undefined ? _data["excludeMethods"] : null as any;
            this.excludeBibliography = _data["excludeBibliography"] !== undefined ? _data["excludeBibliography"] : null as any;
            this.excludeQuotes = _data["excludeQuotes"] !== undefined ? _data["excludeQuotes"] : null as any;
            this.excludeCitations = _data["excludeCitations"] !== undefined ? _data["excludeCitations"] : null as any;
        }
    }

    static fromJS(data: any): ApiTcaReportSettings {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTcaReportSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["excludeAbstract"] = this.excludeAbstract !== undefined ? this.excludeAbstract : null as any;
        data["excludeSmallMatches"] = this.excludeSmallMatches !== undefined ? this.excludeSmallMatches : null as any;
        data["excludeMethods"] = this.excludeMethods !== undefined ? this.excludeMethods : null as any;
        data["excludeBibliography"] = this.excludeBibliography !== undefined ? this.excludeBibliography : null as any;
        data["excludeQuotes"] = this.excludeQuotes !== undefined ? this.excludeQuotes : null as any;
        data["excludeCitations"] = this.excludeCitations !== undefined ? this.excludeCitations : null as any;
        return data;
    }
}

export interface IApiTcaReportSettings {
    excludeAbstract?: boolean;
    excludeSmallMatches?: boolean;
    excludeMethods?: boolean;
    excludeBibliography?: boolean;
    excludeQuotes?: boolean;
    excludeCitations?: boolean;
}

export class ApiProjectInfo implements IApiProjectInfo {
    id?: number;
    name?: string | null;
    status?: ProjectStatusEnum;
    isReadonly?: boolean;
    commentsCount?: number;

    constructor(data?: IApiProjectInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.isReadonly = _data["isReadonly"] !== undefined ? _data["isReadonly"] : null as any;
            this.commentsCount = _data["commentsCount"] !== undefined ? _data["commentsCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiProjectInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ApiProjectInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["isReadonly"] = this.isReadonly !== undefined ? this.isReadonly : null as any;
        data["commentsCount"] = this.commentsCount !== undefined ? this.commentsCount : null as any;
        return data;
    }
}

export interface IApiProjectInfo {
    id?: number;
    name?: string | null;
    status?: ProjectStatusEnum;
    isReadonly?: boolean;
    commentsCount?: number;
}

export enum ProjectStatusEnum {
    InWork = 0,
    Completed = 1,
    Canceled = 2,
    Returned = 3,
}

export class ApiProject implements IApiProject {
    name: string;

    constructor(data?: IApiProject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
        }
    }

    static fromJS(data: any): ApiProject {
        data = typeof data === 'object' ? data : {};
        let result = new ApiProject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        return data;
    }
}

export interface IApiProject {
    name: string;
}

export class ApiPageResultOfApiProjectThemaListItem implements IApiPageResultOfApiProjectThemaListItem {
    items?: ApiProjectThemaListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiProjectThemaListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiProjectThemaListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiProjectThemaListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiProjectThemaListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiProjectThemaListItem {
    items?: ApiProjectThemaListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiProjectThemaListItem implements IApiProjectThemaListItem {
    @keyMap()
    id?: number;
    @columnMap(() => String)
    name?: string | null;

    constructor(data?: IApiProjectThemaListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
        }
    }

    static fromJS(data: any): ApiProjectThemaListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiProjectThemaListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        return data;
    }
}

export interface IApiProjectThemaListItem {
    id?: number;
    name?: string | null;
}

export class ApiProjectDetails implements IApiProjectDetails {
    titleName?: string | null;
    titleIsbn?: string | null;
    kurzel?: string | null;
    reportFile?: ApiFileInfo | null;

    constructor(data?: IApiProjectDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleName = _data["titleName"] !== undefined ? _data["titleName"] : null as any;
            this.titleIsbn = _data["titleIsbn"] !== undefined ? _data["titleIsbn"] : null as any;
            this.kurzel = _data["kurzel"] !== undefined ? _data["kurzel"] : null as any;
            this.reportFile = _data["reportFile"] ? ApiFileInfo.fromJS(_data["reportFile"]) : null as any;
        }
    }

    static fromJS(data: any): ApiProjectDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ApiProjectDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleName"] = this.titleName !== undefined ? this.titleName : null as any;
        data["titleIsbn"] = this.titleIsbn !== undefined ? this.titleIsbn : null as any;
        data["kurzel"] = this.kurzel !== undefined ? this.kurzel : null as any;
        data["reportFile"] = this.reportFile ? this.reportFile.toJSON() : null as any;
        return data;
    }
}

export interface IApiProjectDetails {
    titleName?: string | null;
    titleIsbn?: string | null;
    kurzel?: string | null;
    reportFile?: ApiFileInfo | null;
}

export class ApiImportPapersResult implements IApiImportPapersResult {
    validationMessages?: string[] | null;

    constructor(data?: IApiImportPapersResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["validationMessages"])) {
                this.validationMessages = [] as any;
                for (let item of _data["validationMessages"])
                    this.validationMessages!.push(item);
            }
            else {
                this.validationMessages = null as any;
            }
        }
    }

    static fromJS(data: any): ApiImportPapersResult {
        data = typeof data === 'object' ? data : {};
        let result = new ApiImportPapersResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.validationMessages)) {
            data["validationMessages"] = [];
            for (let item of this.validationMessages)
                data["validationMessages"].push(item);
        }
        return data;
    }
}

export interface IApiImportPapersResult {
    validationMessages?: string[] | null;
}

export class ApiPageResultOfApiProjectListItem implements IApiPageResultOfApiProjectListItem {
    items?: ApiProjectListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiProjectListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiProjectListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiProjectListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiProjectListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiProjectListItem {
    items?: ApiProjectListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiProjectListItem implements IApiProjectListItem {
    @columnMap(() => Number)
    @keyMap()
    id?: number;
    @columnMap(() => String)
    projectName?: string | null;
    @columnMap(() => String)
    titleIsbn?: string | null;
    @columnMap(() => ProjectStatusEnum)
    status?: ProjectStatusEnum;
    @columnMap(() => Date)
    createdDateTime?: Date;

    constructor(data?: IApiProjectListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.projectName = _data["projectName"] !== undefined ? _data["projectName"] : null as any;
            this.titleIsbn = _data["titleIsbn"] !== undefined ? _data["titleIsbn"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.createdDateTime = _data["createdDateTime"] ? new Date(_data["createdDateTime"].toString()) : null as any;
        }
    }

    static fromJS(data: any): ApiProjectListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiProjectListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["projectName"] = this.projectName !== undefined ? this.projectName : null as any;
        data["titleIsbn"] = this.titleIsbn !== undefined ? this.titleIsbn : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : null as any;
        return data;
    }
}

export interface IApiProjectListItem {
    id?: number;
    projectName?: string | null;
    titleIsbn?: string | null;
    status?: ProjectStatusEnum;
    createdDateTime?: Date;
}

export class ApiProjectCreateRequest implements IApiProjectCreateRequest {
    name: string;
    titleId: number;
    onlyAcceptedPapers: boolean;

    constructor(data?: IApiProjectCreateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.titleId = _data["titleId"] !== undefined ? _data["titleId"] : null as any;
            this.onlyAcceptedPapers = _data["onlyAcceptedPapers"] !== undefined ? _data["onlyAcceptedPapers"] : null as any;
        }
    }

    static fromJS(data: any): ApiProjectCreateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ApiProjectCreateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["titleId"] = this.titleId !== undefined ? this.titleId : null as any;
        data["onlyAcceptedPapers"] = this.onlyAcceptedPapers !== undefined ? this.onlyAcceptedPapers : null as any;
        return data;
    }
}

export interface IApiProjectCreateRequest {
    name: string;
    titleId: number;
    onlyAcceptedPapers: boolean;
}

export class ApiThema implements IApiThema {
    code?: string | null;
    parentCode?: string | null;
    heading?: string | null;

    constructor(data?: IApiThema) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.parentCode = _data["parentCode"] !== undefined ? _data["parentCode"] : null as any;
            this.heading = _data["heading"] !== undefined ? _data["heading"] : null as any;
        }
    }

    static fromJS(data: any): ApiThema {
        data = typeof data === 'object' ? data : {};
        let result = new ApiThema();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["parentCode"] = this.parentCode !== undefined ? this.parentCode : null as any;
        data["heading"] = this.heading !== undefined ? this.heading : null as any;
        return data;
    }
}

export interface IApiThema {
    code?: string | null;
    parentCode?: string | null;
    heading?: string | null;
}

export class ApiTopic implements IApiTopic {
    order?: number;
    heading?: string | null;

    constructor(data?: IApiTopic) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"] !== undefined ? _data["order"] : null as any;
            this.heading = _data["heading"] !== undefined ? _data["heading"] : null as any;
        }
    }

    static fromJS(data: any): ApiTopic {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTopic();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order !== undefined ? this.order : null as any;
        data["heading"] = this.heading !== undefined ? this.heading : null as any;
        return data;
    }
}

export interface IApiTopic {
    order?: number;
    heading?: string | null;
}

export class ApiFindTitleRequest implements IApiFindTitleRequest {
    query?: string | null;
    excludedTitleIdArray?: number[] | null;

    constructor(data?: IApiFindTitleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.query = _data["query"] !== undefined ? _data["query"] : null as any;
            if (Array.isArray(_data["excludedTitleIdArray"])) {
                this.excludedTitleIdArray = [] as any;
                for (let item of _data["excludedTitleIdArray"])
                    this.excludedTitleIdArray!.push(item);
            }
            else {
                this.excludedTitleIdArray = null as any;
            }
        }
    }

    static fromJS(data: any): ApiFindTitleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ApiFindTitleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["query"] = this.query !== undefined ? this.query : null as any;
        if (Array.isArray(this.excludedTitleIdArray)) {
            data["excludedTitleIdArray"] = [];
            for (let item of this.excludedTitleIdArray)
                data["excludedTitleIdArray"].push(item);
        }
        return data;
    }
}

export interface IApiFindTitleRequest {
    query?: string | null;
    excludedTitleIdArray?: number[] | null;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(() => result);
    else
        return _observableThrow(() => new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<any> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            if (typeof window === 'undefined') {
                observer.next(blob);
                observer.complete();
            } else {
                let reader = new FileReader();
                reader.onload = event => {
                    observer.next((event.target as any).result);
                    observer.complete();
                };
                reader.readAsText(blob);
            }
        }
    });
}

/* tslint:disable */
/* eslint-disable */